export interface ReportItem {
  id: string;
  category: string;
  tag: string;
  title: string;
  summary: string;
  author: string;
  date: string;
  views: string;
  length: string;
  image: string;
  hot?: boolean;
  featured?: boolean;
  body: string[];
}

export const CATEGORIES = [
  { key: '全部', icon: 'ri-menu-2-line' },
  { key: '职场', icon: 'ri-briefcase-2-line' },
  { key: '民生', icon: 'ri-home-heart-line' },
  { key: '财经', icon: 'ri-line-chart-line' },
  { key: '教育', icon: 'ri-graduation-cap-line' },
  { key: '社会', icon: 'ri-earth-line' },
];

export const CHANNELS = [
  {
    id: 'channel-anon',
    icon: 'ri-user-unfollow-line',
    name: '匿名投稿',
    desc: '无需任何身份信息，通过加密表单直接提交线索材料，全程不留痕。',
    steps: ['填写线索类型与标题', '粘贴文字或上传材料', '一键提交，身份匿名'],
  },
  {
    id: 'channel-dm',
    icon: 'ri-mail-send-line',
    name: '私信爆料',
    desc: '可通过官方私信渠道单独沟通，适合沟通线索细节、补充证据的深度交流。',
    steps: ['私信今日爆料官方号', '对话中描述线索概况', '按引导补充材料'],
  },
  {
    id: 'channel-tip',
    icon: 'ri-map-pin-user-line',
    name: '在线线索征集',
    desc: '面向特定主题发起公开征集，方便聚焦某一行业或事件的集体线索汇总。',
    steps: ['关注当期征集主题', '按框架提交相关信息', '交叉验证后成稿'],
  },
];

export const REPORTS: ReportItem[] = [
  {
    id: 'r1',
    category: '职场',
    tag: '独家调查',
    title: '一份员工体检报告背后：某厂连续三年的“加班文化”样本调查',
    summary: '通过对多位匿名知情人的交叉核实，还原一家制造企业连续三年的超时工作常态，以及制度层面的应对逻辑。',
    author: '深度组 · 一线核实',
    date: '今日 09:40',
    views: '8.2万',
    length: '约8分钟',
    hot: true,
    featured: true,
    image: 'https://readdy.ai/api/search-image?query=a%20dim%20moody%20factory%20workshop%20at%20night%20with%20rows%20of%20machines%2C%20single%20worker%20silhouette%20in%20distance%2C%20industrial%20documentary%20photojournalism%20style%2C%20dramatic%20chiaroscuro%20lighting%2C%20warm%20incandescent%20tone%2C%20editorial%20investigative%20report%20cover%20image&width=1600&height=900&seq=hero-r1-2026&orientation=landscape',
    body: [
      '这是一次历时近两个月的交叉核实。我们陆续收到来自同一工业园区多名在职与离职员工的匿名投稿，线索相互独立却高度一致：固定周期内的高强度排班、长期被压缩的休息时间，以及与之配套的薪酬计算方式。',
      '为避免以偏概全，调查组通过私信渠道与部分知情人士反复沟通，获取了多份相互印证的时间记录与排班截图。我们隐去了一切可定位到个人的细节，只保留能够说明行业普遍现象的关键信息。',
      '报道的目的不是指向某一家具体企业，而是呈现一种被长期默许的工作惯性。我们相信，只有当越来越多的人愿意说出真实的工作状态，制度的改进才可能真正发生。',
      '我们依然欢迎更多知情人士通过匿名投稿补充线索，也承诺会对每一位爆料者的身份进行最大限度的保护。',
    ],
  },
  {
    id: 'r2',
    category: '民生',
    tag: '线索跟进',
    title: '老旧小区加装电梯停滞背后：签字难，到底难在“哪一层”？',
    summary: '一栋楼、两份名单、三拨人。我们追访多地居民的匿名反馈，梳理加装电梯推进缓慢的真实堵点。',
    author: '民生观察组',
    date: '昨日 18:20',
    views: '6.5万',
    length: '约6分钟',
    image: 'https://readdy.ai/api/search-image?query=old%20residential%20apartment%20building%20in%20china%20with%20aging%20exterior%20and%20narrow%20staircases%2C%20quiet%20residential%20lane%2C%20documentary%20photojournalism%2C%20soft%20natural%20daylight%2C%20realistic%20candid%20street%20scene%2C%20warm%20neutral%20tones&width=1200&height=800&seq=r2-2026&orientation=landscape',
    body: [
      '加装电梯本是为解决高层住户出行难的好事，却在推进中常常卡在签字环节。我们汇总了来自多个城市居民的匿名私信，发现真正难以统一的，往往不是费用分摊，而是信息不对称与信任缺失。',
      '有居民反映，最了解方案的往往是热心牵头人，而低层住户对采光、噪音、结构影响的疑虑缺少面对面的回应渠道。也有人提到，公示环节流于形式，让反对的声音更难被听见。',
      '我们呼吁将方案沟通前置、公开透明，并建议引入第三方评估。线索已同步给相关栏目跟进，也欢迎更多居民补充所在小区的真实推进情况。',
    ],
  },
  {
    id: 'r3',
    category: '财经',
    tag: '重点追踪',
    title: '连锁加盟广告里的“稳赚神话”：投入十万，回本究竟靠什么？',
    summary: '多个城市投资人的匿名反馈指向同一模式：高毛利承诺背后的隐性成本与招商话术。我们为你拆解其中的关键环节。',
    author: '财经调查组',
    date: '3天前',
    views: '9.1万',
    length: '约7分钟',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=stack%20of%20renminbi%20notes%20and%20franchise%20business%20contract%20documents%20on%20wooden%20desk%2C%20overhead%20flat%20lay%2C%20financial%20investigative%20report%20photography%2C%20moody%20dramatic%20lighting%2C%20warm%20tones%2C%20money%20and%20risk%20concept&width=1200&height=800&seq=r3-2026&orientation=landscape',
    body: [
      '“总部扶持、月入过万、稳赚不赔”的加盟广告并不罕见。但在我们收到的数十条投资人匿名反馈中，同样的话术反复出现，而事后核算的账目却大相径庭。',
      '拆解下来，核心成本往往藏在三处：首批进货价与市场价的价差、被要求完成的月度任务量，以及“区域保护”条款中模糊的边界。话术里的回本周期，多数没有把租金、人工与损耗算进去。',
      '我们建议有意加盟的朋友，先让第三方核对供货价，再计算真实回本模型。若你已经遭遇疑似夸大宣传，欢迎通过在线线索征集或匿名投稿提供完整合同供我们进一步跟进。',
    ],
  },
  {
    id: 'r4',
    category: '教育',
    tag: '一线声音',
    title: '午休时间被“自愿”占用：多地家长的匿名留言说出了什么？',
    summary: '一条线索引发数百条共鸣。我们整理了家长群体关于课时安排的真实感受与呼吁。',
    author: '教育观察组',
    date: '5天前',
    views: '4.8万',
    length: '约5分钟',
    image: 'https://readdy.ai/api/search-image?query=school%20children%20with%20backpacks%20walking%20in%20a%20sunlit%20campus%20corridor%2C%20soft%20afternoon%20light%2C%20documentary%20photojournalism%2C%20candid%20realistic%20style%2C%20warm%20natural%20tones%2C%20education%20report&width=1200&height=800&seq=r4-2026&orientation=landscape',
    body: [
      '一位家长在匿名投稿中写道：“孩子中午几乎没有完整的休息时间。”这条看似普通的线索，在栏目内引发了数百条相似回应，覆盖多座城市的多个学段。',
      '我们并非主张一刀切，而是希望看到真实课表与休息时间的完整呈现。合理的作息不是“加量”的附属品，它本身就是学习质量的一部分。',
      '我们欢迎老师与校方也能加入讨论，从一线视角补充更完整的图景，让讨论回归理性与真实。',
    ],
  },
  {
    id: 'r5',
    category: '社会',
    tag: '网友爆料',
    title: '“三天两夜低价游”里的购物环节：一份行程单引发的大讨论',
    summary: '从一条私信线索出发，网友纷纷晒出相似的行程单。低价背后，隐藏的消费安排比想象中更普遍。',
    author: '消费维权组',
    date: '上周',
    views: '7.3万',
    length: '约6分钟',
    image: 'https://readdy.ai/api/search-image?query=busload%20of%20tourists%20at%20a%20large%20gift%20shop%20with%20souvenirs%20and%20shelves%2C%20travel%20documentary%20photography%2C%20busy%20tourist%20scene%2C%20realistic%20natural%20light%2C%20warm%20tones&width=1200&height=800&seq=r5-2026&orientation=landscape',
    body: [
      '“行程单上明明写着自由活动，到了现场却变成了购物点集合。”一条私信让大量网友产生共鸣，大家在评论区晒出惊人相似的行程安排。',
      '低价团的经济模型决定了它的收入补偿来自购物返佣，这本不新鲜。真正让消费者困扰的，是“自愿购物”与“变相强制”之间模糊的边界。',
      '如果你手中有完整的行程单、购物票据或宣传截图，欢迎通过在线线索征集提交。我们将尝试将零散的个案整理成可参考的避坑清单。',
    ],
  },
];

export const FAQS = [
  {
    q: '匿名投稿真的能保证我的身份不泄露吗？',
    a: '可以。匿名投稿表单不要求填写任何姓名、联系方式等身份信息，提交的材料也会经过脱敏处理。调查组在核实线索时，只关注材料本身，不保留与个人身份相关的定位信息。',
  },
  {
    q: '私信爆料和匿名投稿有什么区别？',
    a: '匿名投稿适合一次性提交相对完整的文字或材料；私信爆料则更适合需要与记者来回沟通线索细节、补充证据的场景。两种方式都可选择匿名沟通，具体取决于你掌握的线索完整程度。',
  },
  {
    q: '提交线索后，多久会有人跟进？',
    a: '我们在收到线索后会进行初步分类与真伪判断。具备新闻价值且材料相对完整的线索，通常会在 1—3 个工作日内进入核实流程；因线索量较大，部分投稿可能需要更长时间，请耐心等待。',
  },
  {
    q: '哪些内容不适合投稿？',
    a: '我们不接受纯粹的私人纠纷、涉及他人隐私的无依据指控，以及明显失实的情绪化内容。投稿需基于事实，最好能附上可核验的材料。对存疑线索，我们会先与线索人确认。',
  },
  {
    q: '报道上线前会通知线索提供者吗？',
    a: '对参与深度核实的线索，我们会尽量在上线前与匿名沟通渠道同步核心事实的表述口径，确保引述准确。出于保护考虑，我们不会在报道中透露任何可能指向线索人的信息。',
  },
];

export const PRINCIPLES = [
  {
    icon: 'ri-shield-check-line',
    title: '隐私优先',
    desc: '全流程匿名化，材料脱敏处理，报道不指向任何可定位的爆料者。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '交叉核实',
    desc: '重要结论尽量获取多方印证，宁缺毋滥，不为了热度牺牲准确。',
  },
  {
    icon: 'ri-focus-2-line',
    title: '只谈事实',
    desc: '剥离情绪与猜测，把事件放在制度与语境中，让读者自己判断。',
  },
  {
    icon: 'ri-question-answer-line',
    title: '开放回应',
    desc: '给被报道方以回应机会，尊重每一条真实的声音。',
  },
];